/**
 * Copyright IBM Corp. 2022
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */

import TriBimViewer from "./TriBimViewer.js";

export
{
    TriBimViewer,
};
